import * as React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogClose,
  DialogFooter,
} from "../components/ui/dialog";
import { Button } from "./ui/button";

type Props = {
  open: boolean;
  onOpenChange: (v: boolean) => void;

  onBack?: () => void | Promise<void>;
  closeOnBack?: boolean;
  backText?: string;
  okText?: string;

  title?: string;
  message?: string;
  showCloseIcon?: boolean;
  allowClose?: boolean;
};

export default function NonScheduleDialog({
  open,
  onOpenChange,
  onBack,
  backText,
  allowClose = true,
  okText = "OK",
  message = "Không tìm thấy bác sĩ trống lịch theo phòng khám bạn chọn.",
}: Props) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        showCloseButton={false}
        onEscapeKeyDown={(e) => {!allowClose && e.preventDefault()}}
        onPointerDownOutside={(e) => {!allowClose && e.preventDefault()}}
        onInteractOutside={(e) => {!allowClose && e.preventDefault()}}
        className="p-4 w-[400px] rounded-xl overflow-hidden shadow-2xl"
      >
        {/* tránh warning */}
        <DialogHeader className="sr-only">
          <DialogTitle>Không có lịch khám phù hợp</DialogTitle>
          <DialogDescription>{message}</DialogDescription>
        </DialogHeader>

        <div className="flex flex-col items-center">
          <img className="w-[120px] h-[120px]" src="/images/non-schedule.svg" />
          <p className="px-[2rem] mt-4 text-green-900 text-center">{message}</p>
        </div>
        <DialogFooter className="flex justify-center">
          <DialogClose asChild>
            {backText ? (
              <Button onClick={onBack} className="px-8">
                {backText}
              </Button>
            ) : (
              <Button className="px-8">{okText}</Button>
            )}
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
